module.exports = __webpack_public_path__ + "static/media/fat_rabbit.push.16396513.jpeg";